import React, { useState } from 'react';
import { Button, MenuItem, DialogTitle, DialogContent, DialogActions, Dialog, TextField, InputLabel } from '@material-ui/core';
import SystemLabel from '../../../system/SystemLabel/SystemLabel';

export default function CreateChannelDialog({ parentEventId, eventList, handleClose, save }) {
    const [selectedEvent, setSelectedEvent] = useState(parentEventId);
    const [newChannelName, setNewChannelName] = useState("");
    const saveClick = () => {
        if (selectedEvent && newChannelName) {
            save(selectedEvent, newChannelName);
        }
    }
    return (
        <Dialog
            open={true}
            onClose={handleClose}
            aria-labelledby="create-channel-dialog-title"
        >
            <DialogTitle id="create-channel-dialog-title"><SystemLabel name={"CreateChannelDialogTitle"} /> </DialogTitle>
            <DialogContent>
                <InputLabel><SystemLabel name={"CreateChannelEventId"} /></InputLabel>
                <TextField
                    value={selectedEvent}
                    required
                    select
                    margin="dense"
                    fullWidth
                    // label="Rum"
                    onChange={(e) => setSelectedEvent(e.target.value)}
                >
                    {eventList.map((ev) => {
                        return <MenuItem key={ev.eventId} value={ev.eventId}>{ev.name}</MenuItem>
                    })}
                </TextField>
                <InputLabel><SystemLabel name={"CreateChannelName"} /></InputLabel>
                <TextField
                    value={newChannelName}
                    autoFocus
                    required
                    margin="dense"
                    type="text"
                    fullWidth
                    onChange={(e) => setNewChannelName(e.target.value)}
                />

            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                <SystemLabel name={"CreateChannelCancel"} />
                </Button>
                <Button onClick={saveClick} color="primary">
                <SystemLabel name={"CreateChannelSave"} />
                </Button>
            </DialogActions>
        </Dialog>
    );
}